module.exports = __webpack_public_path__ + "static/img/6.539f564.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/6.png
// module id = XHqz
// module chunks = 0